export enum RegistrationErrorType {
  InvalidInformation = 1,
  BoxOffline = 2,
}

export namespace RegistrationErrorType {
  export function fromErrorCode(errorCode: number) {
    switch (errorCode) {
      case 409:
        return RegistrationErrorType.InvalidInformation;
      case 428:
        return RegistrationErrorType.BoxOffline;
      default:
        throw new Error(`Unknown error code: ${errorCode}`);
    }
  }
}
